import { ORDER, Order } from '@favid-inc/api';
import { Get, OrderByElement } from '@favid-inc/api/lib/rest';
import { Action, Filter } from 'core/generic';

import { request as client } from 'utils';
import { State } from './ListOrders';

import {
  BEFORE_FETCH_ORDERS,
  ON_ERROR_FETCH_ORDERS,
  ON_FETCH_ORDERS,
} from './types';

export const reducerOrders = (
  currentState: State,
  { type, payload }: Action,
) => {
  switch (type) {
    case BEFORE_FETCH_ORDERS:
      return { ...currentState, isLoading: true };
    case ON_FETCH_ORDERS:
      return { ...currentState, ...payload, isLoading: false };
    default:
      return currentState;
  }
};

interface FetchOrdersParams {
  filter: Filter & {};
  orderBy: OrderByElement;
  dispatch: (action: Action) => void;
}

export const fetchOrders = async (params: FetchOrdersParams) => {
  const { dispatch, orderBy } = params;
  const { itensPerPage, page, where } = params.filter;

  dispatch({
    type: BEFORE_FETCH_ORDERS,
  });

  try {
    type GetOrdersAction = Get<Order>;
    const request: GetOrdersAction['Request'] = {
      url: `/${ORDER}`,
      method: 'GET',
      params: {
        where,
        limit: itensPerPage,
        offset: itensPerPage * page,
        orderBy: [orderBy],
        // orderBy: [{ attr: 'customerName', exp: 'ASC' as 'ASC' }],
      },
    };
    const response = await client.request<GetOrdersAction['Response']>(request);
    dispatch({
      type: ON_FETCH_ORDERS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: ON_ERROR_FETCH_ORDERS,
    });
  }
};
